import { lazy } from 'react';
import { LoadingComponent } from '../../../../components/effect/LoadingComponent';
import RoleBasedGuard from '../../../../guards/RoleBasedGuard';
import { USER_ROLES} from '../../../../constants';

const OrderList = LoadingComponent(lazy(() => import('./OrderList')));
const OrderCreate = LoadingComponent(lazy(() => import('./OrderCreate')));
const OrderConfirmToyotsu = LoadingComponent(lazy(() => import('./OrderConfirmToyotsu')));
const OrderConfirmMaker = LoadingComponent(lazy(() => import('./OrderConfirmMaker')));

export const orderRoute = {
  path: 'order',
  children: [
    {
      path: '',
      element: (
        <RoleBasedGuard accessibleRoles={[
          USER_ROLES.FLOUR_CUSTOMER,
          USER_ROLES.FLOUR_TOYOTSU,
          USER_ROLES.FLOUR_MAKER,
          USER_ROLES.FLOUR_ADMIN,
        ]}>
          <OrderList />
        </RoleBasedGuard>
      ),
      exact: true,
    },
    {
      path: ':id',
      element: (
        <RoleBasedGuard accessibleRoles={[
          USER_ROLES.FLOUR_CUSTOMER,
          USER_ROLES.FLOUR_ADMIN,
        ]}>
          <OrderCreate />
        </RoleBasedGuard>
      ),
    },
    {
      path: 'create',
      element: (
        <RoleBasedGuard accessibleRoles={[
          USER_ROLES.FLOUR_CUSTOMER,
          USER_ROLES.FLOUR_ADMIN,
        ]}>
          <OrderCreate />
        </RoleBasedGuard>
      ),
    },
    {
      path: 'confirm-maker',
      children: [
        {
          path: '',
          element: (
            <RoleBasedGuard accessibleRoles={[
              USER_ROLES.FLOUR_MAKER,
              USER_ROLES.FLOUR_ADMIN,
            ]}>
              <OrderConfirmMaker />
            </RoleBasedGuard>
          ),
          exact: true,
        },
        {
          path: ':id',
          element: (
            <RoleBasedGuard accessibleRoles={[
              USER_ROLES.FLOUR_MAKER,
              USER_ROLES.FLOUR_ADMIN,
            ]}>
              <OrderConfirmMaker />
            </RoleBasedGuard>
          ),
        },
      ],
    },
    {
      path: 'confirm-toyotsu',
      children: [
        {
          path: '',
          element: (
            <RoleBasedGuard accessibleRoles={[
              USER_ROLES.FLOUR_TOYOTSU,
              USER_ROLES.FLOUR_ADMIN,
            ]}>
              <OrderConfirmToyotsu />
            </RoleBasedGuard>
          ),
          exact: true,
        },
        {
          path: ':id',
          element: (
            <RoleBasedGuard accessibleRoles={[
              USER_ROLES.FLOUR_TOYOTSU,
              USER_ROLES.FLOUR_ADMIN,
            ]}>
              <OrderConfirmToyotsu />
            </RoleBasedGuard>
          ),
        },
      ],
    },
  ],
};
